import React from "react";
import { connect } from "react-redux";
import $ from "jquery";

import {togglePulseFeatureInfoQuantity} from "../../../actions/actionFunctions";
import {toggleProductNoteEditorVisible} from "../../../actions/selectionFunctions";
import {getCartItemObject} from "../../../misc/helpers";


export default (WrappedComponent) => {

  const WithMaterialsWizardFooterCommon = (props) => {

    const {selectionInfoQuantity, selectionFeatureInfo, togglePulseFeatureInfoQuantity, toggleProductNoteEditorVisible,
      relatedGroups, qtActiveCategory, selectionGroup} = props;

    const quantityIsZero = () => {
      if (!selectionInfoQuantity && selectionFeatureInfo && !selectionFeatureInfo.dbFeature.hideQuantity) {
        togglePulseFeatureInfoQuantity(true);
        toggleProductNoteEditorVisible(false); // exit add note mode
        const $scrollableInfoArea = $(".selection-main__info-scrollable");
        if ($scrollableInfoArea) {
          $scrollableInfoArea.animate({scrollTop: 0}, 500);
        }
        return true;
      }
      return false
    }

    const getCartFeatureParentName = (activeFeature) => {
      let parentName = selectionGroup;
      if (activeFeature.getParent) {
        const subPart = activeFeature.getParent();
        parentName = subPart.getParent ? subPart.getParent().partName : subPart.partName
      }
      return parentName
    }

    const getCurrentRelatedCartItems = (activeFeature, arrayToAddtoTheCart = []) => {
      if (Array.isArray(relatedGroups) && relatedGroups.length) {
        relatedGroups.forEach(relatedGroup => {
          relatedGroup.relatedFeatures.forEach(relatedFeature => {
            if (relatedFeature.cartQuantity) {
              const relatedItemCartObject = getCartItemObject(relatedFeature, relatedFeature.cartQuantity, qtActiveCategory);
              relatedItemCartObject.relatedProductParent = activeFeature;
              arrayToAddtoTheCart.push(relatedItemCartObject)
            }
          });
        });
      }
      return arrayToAddtoTheCart
    }

    return <WrappedComponent {...props}
                             quantityIsZero={quantityIsZero}
                             getCurrentRelatedCartItems={getCurrentRelatedCartItems}
                             getCartFeatureParentName={getCartFeatureParentName}/>

  };

  const mapStateToProps = (store) => {
    const {selectionFeatureInfo, selectionInfoQuantity, relatedGroups, selectionGroup} = store.selectionState;
    const {qtActiveCategory} = store.qtState;

    return {
      selectionFeatureInfo,
      selectionInfoQuantity,
      relatedGroups,
      qtActiveCategory,
      selectionGroup,
    };
  };

  const mapDispatchToProps = {
    togglePulseFeatureInfoQuantity,
    toggleProductNoteEditorVisible,
  };

  return connect(mapStateToProps, mapDispatchToProps)(WithMaterialsWizardFooterCommon)
}
